import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { ProviderConnection } from "@/components/pages/integrations/components/common/types/common";

export interface ActiveProviderConnectionConfig {
  step: number;
  isCommandGenerated?: boolean;
  isConnectionCreated?: boolean;
}

export interface ActiveProviderConnection {
  id: string | null;
  type: ProviderConnection | null;
  config: ActiveProviderConnectionConfig;
}

export interface ProviderConnectionsState {
  currentProviderConnectionType: ProviderConnection | null;
  activeProviderConnection: ActiveProviderConnection;
}

const initialState: ProviderConnectionsState = {
  currentProviderConnectionType: null,
  activeProviderConnection: {
    id: null,
    type: null,
    config: {
      step: 0,
    },
  },
};

export const providerConnectionsSlice = createSlice({
  name: "providerConnections",
  initialState: initialState,
  reducers: {
    setActiveProviderConnectionType: (
      state,
      action: PayloadAction<ActiveProviderConnection["type"]>,
    ) => {
      state.activeProviderConnection.type = action.payload;
    },
    setActiveProviderConnectionActiveStep: (
      state,
      action: PayloadAction<ActiveProviderConnection["config"]["step"]>,
    ) => {
      state.activeProviderConnection.config.step = action.payload;
    },
    setActiveProviderConnectionIsCommandGenerated: (
      state,
      action: PayloadAction<
        ActiveProviderConnection["config"]["isCommandGenerated"]
      >,
    ) => {
      state.activeProviderConnection.config.isCommandGenerated = action.payload;
    },
    setActiveProviderConnectionIsCreated: (
      state,
      action: PayloadAction<
        ActiveProviderConnection["config"]["isConnectionCreated"]
      >,
    ) => {
      state.activeProviderConnection.config.isConnectionCreated =
        action.payload;
    },
  },
});

export const {
  setActiveProviderConnectionType,
  setActiveProviderConnectionActiveStep,
  setActiveProviderConnectionIsCommandGenerated,
  setActiveProviderConnectionIsCreated,
} = providerConnectionsSlice.actions;

export default providerConnectionsSlice.reducer;
